import { lazy, Suspense } from 'react'
import Loader from '../custom/loader/main';

const Main = lazy(() => import('../components/setup/departments/main'));

const Departments = () => {
  return (
    <Suspense fallback={<Loader/>}>
      <Main/>
    </Suspense>
  )
}

export default Departments;